export default __webpack_public_path__ + "static/media/codechefIcon.b238da34.svg";